import {withMaterialStyles as defaultWithMaterialStyles, withMaterialTheme as defaultWithMaterialTheme} from "configurator-studio-arkitekter-components/dist/common/components/Template/withMaterial";

export const withMaterialStyles = defaultWithMaterialStyles;
export const withMaterialTheme = defaultWithMaterialTheme;
